import { useState } from 'react';

import { Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateRangePicker, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { ptBR } from 'date-fns/locale';

import { DeviceAutoComplete } from 'components/autocompletes/DeviceAutoComplete';
import { ModuleAutoComplete } from 'components/autocompletes/ModuleAutoComplete';
import { CissTextField, StatusField } from 'components/fields';
import { Filter } from 'components/filter';
import { usePermissionsContext } from 'context/PermissionsContext';
import { FilterValuesProps } from 'hooks/useFilter';

export function FormFilterBanner() {
    const { hasPermission } = usePermissionsContext();

    const [filterTitulo, setFilterTitulo] = useState<FilterValuesProps>({
        property: 'dsBanner',
        operator: 'like',
        value: '',
    });

    const [filterDevice, setFilterDevice] = useState<FilterValuesProps>({
        property: 'idTipoDispositivo',
        operator: 'in',
        value: null,
        idProperty: 'idTipoDispositivo',
    });

    const [filterModule, setFilterModule] = useState<FilterValuesProps>({
        property: 'idModulo',
        operator: 'in',
        value: [],
        idProperty: 'idModulo',
    });

    const [filterInterval, setFilterInterval] = useState<FilterValuesProps>({
        property: 'dtInicioVigencia',
        operator: 'bt',
        startDate: null,
        endDate: null,
    });

    const [filterStatus, setFilterStatus] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        operator: 'eq',
        value: true,
        idProperty: 'vlStatus',
    });

    return (
        <Filter
            filters={[
                { value: filterTitulo, setter: setFilterTitulo },
                { value: filterDevice, setter: setFilterDevice },
                { value: filterModule, setter: setFilterModule },
                { value: filterInterval, setter: setFilterInterval },
                { value: filterStatus, setter: setFilterStatus },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Título"
                    value={filterTitulo.value}
                    onChange={(e) => setFilterTitulo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <DeviceAutoComplete
                    label="Dispositivo"
                    value={filterDevice.value}
                    onChange={(e, value) => setFilterDevice((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <ModuleAutoComplete
                    value={filterModule.value}
                    onChange={(e, value) => setFilterModule((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
            <Grid sx={{ width: '100%', flex: 2 }}>
                <LocalizationProvider adapterLocale={ptBR} dateAdapter={AdapterDateFns} localeText={{ start: 'Data Inicial', end: 'Data Final' }}>
                    <DateRangePicker
                        value={[filterInterval.startDate ?? null, filterInterval.endDate ?? null]}
                        onChange={([startDate, endDate]) => {
                            setFilterInterval((oldState: FilterValuesProps) => ({
                                ...oldState,
                                startDate,
                                endDate,
                            }));
                        }}
                        slots={{ field: MultiInputDateRangeField }}
                        slotProps={{
                            field: { dateSeparator: 'até' },
                            textField: { autoComplete: 'off' },
                        }}
                    />
                </LocalizationProvider>
            </Grid>
            {hasPermission(['BANNER_MODERAR']) && (
                <Grid sx={{ flex: 1 }}>
                    <StatusField
                        value={filterStatus.value}
                        onChange={(e, value) => setFilterStatus((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                    />
                </Grid>
            )}
        </Filter>
    );
}
